import React, { useCallback } from "react";
import styles from "../EventsPage.module.css";
import iconMap from "../../../../assets/Icons/event-map.svg";
import iconCalendar from "../../../../assets/Icons/event-calendar.svg";
import iconShare from "../../../../assets/Icons/event-share.svg";
import iconChevronRight from "../../../../assets/Icons/event-chevron-right.svg";

export function UpcomingEventCard({ title, location, dateLabel, websiteUrl }) {
  const onShare = useCallback(async () => {
    const url = window.location.href;
    const payload = { title, text: title, url };
    try {
      if (navigator.share) {
        await navigator.share(payload);
        return;
      }
      await navigator.clipboard?.writeText(url);
    } catch {
    }
  }, [title]);

  return (
    <article className={styles.upcomingCard}>
      <div className={styles.upcomingCardTop}>
        <h3 className={styles.upcomingCardTitle}>{title}</h3>
        <button type="button" className={styles.shareBtn} onClick={onShare}>
          <img className={styles.shareIcon} src={iconShare} alt="" aria-hidden />
          <span>Share</span>
        </button>
      </div>
      <div className={styles.metaRow}>
        <img className={styles.metaIcon} src={iconMap} alt="" aria-hidden />
        <span className={styles.metaText}>{location}</span>
      </div>
      <div className={styles.upcomingCardBottom}>
        <div className={styles.metaRow}>
          <img className={styles.metaIcon} src={iconCalendar} alt="" aria-hidden />
          <span className={styles.metaText}>{dateLabel}</span>
        </div>
        {websiteUrl ? (
          <a
            className={styles.eventWebsiteLink}
            href={websiteUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className={styles.eventWebsiteText}>Event Website</span>
            <img className={styles.linkChevron} src={iconChevronRight} alt="" aria-hidden />
          </a>
        ) : (
          <span className={styles.eventWebsitePlaceholder} aria-hidden />
        )}
      </div>
    </article>
  );
}
